import {
  Landmark,
  BarChart3,
  Users,
  Workflow,
  Home,
  NotebookPen,
  Handshake,
  FolderKanban,
} from "lucide-react";
import { useContext, useState } from "react";
import { GlobalContext } from "../context/Context";

// const Organization = (
//   <svg
//     width="16"
//     height="16"
//     viewBox="0 0 32 30"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <path
//       d="M12.8999 18.8181L12.9092 18.8181"
//       stroke="#222222"
//       strokeWidth="1.4"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M16.6333 18.8181L16.6426 18.8181"
//       stroke="#222222"
//       strokeWidth="1.4"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <path
//       d="M4.5 21.6818C4.5 22.1881 4.69667 22.6737 5.04673 23.0317C5.3968 23.3897 5.8716 23.5908 6.36667 23.5908L19.4333 23.5908C19.9284 23.5908 20.4032 23.3897 20.7533 23.0317C21.1033 22.6737 21.3 22.1881 21.3 21.6818L21.3 11.659C21.3001 11.5734 21.2777 11.4893 21.235 11.4156C21.1924 11.3419 21.1312 11.2813 21.0578 11.2401C20.9844 11.1989 20.9016 11.1787 20.8179 11.1815C20.7342 11.1843 20.6528 11.2101 20.5823 11.2562L16.4177 13.9709C16.3472 14.017 16.2658 14.0428 16.1821 14.0456C16.0984 14.0485 16.0156 14.0282 15.9422 13.987C15.8688 13.9458 15.8076 13.8852 15.765 13.8115C15.7223 13.7378 15.6999 13.6537 15.7 13.5681L15.7 11.659C15.7001 11.5734 15.6777 11.4893 15.635 11.4156C15.5924 11.3419 15.5312 11.2813 15.4578 11.2401C15.3844 11.1989 15.3016 11.1787 15.2179 11.1815C15.1342 11.1843 15.0528 11.2101 14.9823 11.2562L10.8187 13.9709C10.7481 14.0172 10.6666 14.0433 10.5828 14.0462C10.499 14.0492 10.4159 14.029 10.3424 13.9878C10.2688 13.9465 10.2075 13.8858 10.1649 13.812C10.1222 13.7381 10.0998 13.6539 10.1 13.5681L10.1 8.31812C10.1 7.81179 9.90333 7.32621 9.55327 6.96818C9.2032 6.61016 8.7284 6.40903 8.23333 6.40903L6.36667 6.40903C5.8716 6.40903 5.3968 6.61016 5.04673 6.96818C4.69667 7.32621 4.5 7.81179 4.5 8.31812L4.5 21.6818Z"
//       stroke="#222222"
//       strokeWidth="1.4"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <g filter="url(#filter0_d_615_24404)" data-figma-bg-blur-radius="1.9">
//       <path
//         d="M12.5 16.0606C12.5 16.5026 12.6717 16.9266 12.9773 17.2391C13.2829 17.5517 13.6974 17.7273 14.1296 17.7273L25.537 17.7273C25.9692 17.7273 26.3837 17.5517 26.6894 17.2391C26.995 16.9266 27.1667 16.5026 27.1667 16.0606L27.1667 7.31061C27.1667 7.23586 27.1472 7.16246 27.11 7.09812C27.0728 7.03377 27.0193 6.98085 26.9553 6.94489C26.8912 6.90893 26.8188 6.89126 26.7458 6.89373C26.6727 6.8962 26.6017 6.91873 26.5401 6.95894L22.9044 9.32894C22.8428 9.36915 22.7717 9.39168 22.6987 9.39415C22.6256 9.39662 22.5533 9.37895 22.4892 9.34299C22.4251 9.30703 22.3717 9.25411 22.3345 9.18976C22.2973 9.12542 22.2777 9.05202 22.2778 8.97727L22.2778 7.31061C22.2779 7.23586 22.2583 7.16246 22.2211 7.09812C22.1839 7.03377 22.1304 6.98085 22.0664 6.94489C22.0023 6.90893 21.9299 6.89126 21.8569 6.89373C21.7838 6.8962 21.7128 6.91873 21.6512 6.95894L18.0163 9.32894C17.9547 9.36937 17.8835 9.39208 17.8104 9.39466C17.7372 9.39725 17.6647 9.37962 17.6005 9.34364C17.5363 9.30765 17.4828 9.25463 17.4455 9.19016C17.4083 9.12569 17.3887 9.05215 17.3889 8.97727L17.3889 4.39394C17.3889 3.95191 17.2172 3.52799 16.9116 3.21543C16.606 2.90287 16.1915 2.72727 15.7593 2.72727L14.1296 2.72727C13.6974 2.72727 13.2829 2.90287 12.9773 3.21543C12.6717 3.52799 12.5 3.95191 12.5 4.39394L12.5 16.0606Z"
//         fill="#FF4086"
//         fillOpacity="0.3"
//         shapeRendering="crispEdges"
//       />
//     </g>
//     <path
//       d="M9.1665 18.8181L9.17584 18.8181"
//       stroke="#222222"
//       strokeWidth="1.4"
//       strokeLinecap="round"
//       strokeLinejoin="round"
//     />
//     <defs>
//       <filter
//         id="filter0_d_615_24404"
//         x="10.6"
//         y="0.827274"
//         width="20.6665"
//         height="22"
//         filterUnits="userSpaceOnUse"
//         colorInterpolationFilters="sRGB"
//       >
//         <feFlood floodOpacity="0" result="BackgroundImageFix" />
//         <feColorMatrix
//           in="SourceAlpha"
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
//           result="hardAlpha"
//         />
//         <feOffset dx="2" dy="3" />
//         <feGaussianBlur stdDeviation="1.05" />
//         <feComposite in2="hardAlpha" operator="out" />
//         <feColorMatrix
//           type="matrix"
//           values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
//         />
//         <feBlend
//           mode="normal"
//           in2="BackgroundImageFix"
//           result="effect1_dropShadow_615_24404"
//         />
//         <feBlend
//           mode="normal"
//           in="SourceGraphic"
//           in2="effect1_dropShadow_615_24404"
//           result="shape"
//         />
//       </filter>
//       <clipPath
//         id="bgblur_0_615_24404_clip_path"
//         transform="translate(-10.6 -0.827274)"
//       >
//         <path d="M12.5 16.0606C12.5 16.5026 12.6717 16.9266 12.9773 17.2391C13.2829 17.5517 13.6974 17.7273 14.1296 17.7273L25.537 17.7273C25.9692 17.7273 26.3837 17.5517 26.6894 17.2391C26.995 16.9266 27.1667 16.5026 27.1667 16.0606L27.1667 7.31061C27.1667 7.23586 27.1472 7.16246 27.11 7.09812C27.0728 7.03377 27.0193 6.98085 26.9553 6.94489C26.8912 6.90893 26.8188 6.89126 26.7458 6.89373C26.6727 6.8962 26.6017 6.91873 26.5401 6.95894L22.9044 9.32894C22.8428 9.36915 22.7717 9.39168 22.6987 9.39415C22.6256 9.39662 22.5533 9.37895 22.4892 9.34299C22.4251 9.30703 22.3717 9.25411 22.3345 9.18976C22.2973 9.12542 22.2777 9.05202 22.2778 8.97727L22.2778 7.31061C22.2779 7.23586 22.2583 7.16246 22.2211 7.09812C22.1839 7.03377 22.1304 6.98085 22.0664 6.94489C22.0023 6.90893 21.9299 6.89126 21.8569 6.89373C21.7838 6.8962 21.7128 6.91873 21.6512 6.95894L18.0163 9.32894C17.9547 9.36937 17.8835 9.39208 17.8104 9.39466C17.7372 9.39725 17.6647 9.37962 17.6005 9.34364C17.5363 9.30765 17.4828 9.25463 17.4455 9.19016C17.4083 9.12569 17.3887 9.05215 17.3889 8.97727L17.3889 4.39394C17.3889 3.95191 17.2172 3.52799 16.9116 3.21543C16.606 2.90287 16.1915 2.72727 15.7593 2.72727L14.1296 2.72727C13.6974 2.72727 13.2829 2.90287 12.9773 3.21543C12.6717 3.52799 12.5 3.95191 12.5 4.39394L12.5 16.0606Z" />
//       </clipPath>
//     </defs>
//   </svg>
// );
const MySpace = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      opacity="0.4"
      d="M13.5318 7.6746C13.5318 6.27568 13.5301 5.29178 13.4301 4.54775C13.3326 3.82256 13.1523 3.42335 12.8645 3.13557C12.5767 2.8478 12.1776 2.66747 11.4523 2.56994C10.7083 2.4699 9.72442 2.46827 8.32548 2.46825H7.67468C6.27576 2.46824 5.29187 2.46991 4.54783 2.56994C3.82262 2.66746 3.42344 2.84779 3.13566 3.13557C2.84788 3.42336 2.66754 3.82252 2.57002 4.54775C2.46999 5.2918 2.46834 6.27565 2.46834 7.6746V8.3254C2.46834 9.72433 2.46999 10.7082 2.57002 11.4523C2.66754 12.1775 2.84788 12.5767 3.13566 12.8644C3.42345 13.1522 3.82256 13.3332 4.54783 13.4307C5.29187 13.5307 6.27575 13.5317 7.67468 13.5317H8.32548C9.72442 13.5317 10.7083 13.5307 11.4523 13.4307C12.1776 13.3332 12.5767 13.1522 12.8645 12.8644C13.1523 12.5767 13.3326 12.1775 13.4301 11.4523C13.5301 10.7082 13.5318 9.72433 13.5318 8.3254V7.6746ZM14.8334 8.3254C14.8334 9.68753 14.8347 10.7748 14.7203 11.6257C14.6033 12.4953 14.3547 13.2154 13.7847 13.7853C13.2149 14.355 12.4953 14.6033 11.6258 14.7202C10.7749 14.8346 9.68762 14.8333 8.32548 14.8333H7.67468C6.31254 14.8333 5.22526 14.8346 4.37432 14.7202C3.50491 14.6033 2.78525 14.355 2.21539 13.7853C1.64548 13.2154 1.39681 12.4953 1.27988 11.6257C1.16547 10.7748 1.16675 9.68753 1.16675 8.3254V7.6746C1.16675 6.31245 1.16547 5.22519 1.27988 4.37424C1.39681 3.50467 1.6455 2.78522 2.21539 2.21531C2.7853 1.64541 3.50478 1.39672 4.37432 1.27979C5.22525 1.1654 6.31256 1.16665 7.67468 1.16667H8.32548C9.68762 1.16668 10.7749 1.16538 11.6258 1.27979C12.4954 1.39673 13.2149 1.64542 13.7847 2.21531C14.3547 2.78521 14.6033 3.50471 14.7203 4.37424C14.8347 5.22517 14.8334 6.31248 14.8334 7.6746V8.3254Z"
      fill="currentColor"
    />
    <path
      d="M8 4.5C9.38073 4.5 10.5 5.61929 10.5 7C10.5 8.38073 9.38073 9.5 8 9.5C6.61929 9.5 5.5 8.38073 5.5 7C5.5 5.61929 6.61929 4.5 8 4.5Z"
      fill="currentColor"
    />
    <path
      d="M12.931 12.7903C12.275 10.6906 10.316 9.16667 8 9.16667C5.68421 9.16667 3.72462 10.6903 3.06836 12.7897C3.09057 12.815 3.11177 12.8409 3.13541 12.8646C3.42319 13.1523 3.82237 13.3335 4.54753 13.431C5.29155 13.531 6.27561 13.5319 7.67447 13.5319H8.32553C9.7244 13.5319 10.7085 13.531 11.4525 13.431C12.1776 13.3335 12.5768 13.1523 12.8646 12.8646C12.888 12.8411 12.909 12.8154 12.931 12.7903Z"
      fill="currentColor"
    />
  </svg>
);

const Team = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      opacity="0.4"
      d="M5.49985 7C5.49985 5.61929 6.61915 4.5 7.99985 4.5C9.38059 4.5 10.4999 5.61929 10.4999 7C10.4999 8.01707 9.89245 8.89233 9.02065 9.2828C10.8032 9.69767 12.1666 11.1743 12.1666 12.9993C12.1666 13.2755 11.9427 13.4993 11.6666 13.4993H4.33325C4.05711 13.4993 3.83325 13.2755 3.83325 12.9993C3.83325 11.1743 5.19663 9.69773 6.97912 9.2828C6.10725 8.89233 5.49985 8.01713 5.49985 7Z"
      fill="currentColor"
      fill-opacity="0.6"
    />
    <path
      d="M4.99985 2.4987C3.61915 2.4987 2.49985 3.61799 2.49985 4.9987C2.49985 6.01581 3.10725 6.89107 3.9791 7.28147C2.19663 7.69647 0.833252 9.17307 0.833252 10.9981C0.833252 11.2742 1.05711 11.4981 1.33325 11.4981H3.08344C3.44821 10.4444 4.18547 9.57353 5.11931 8.98713C4.72891 8.4228 4.49985 7.7378 4.49985 6.99867C4.49985 5.38213 5.59582 4.02154 7.08525 3.61941C6.63767 2.94403 5.87076 2.4987 4.99985 2.4987Z"
      fill="currentColor"
      fill-opacity="0.6"
    />
    <path
      d="M12.9165 11.4981C12.5518 10.4443 11.8144 9.57347 10.8806 8.98707C11.271 8.42273 11.5 7.73773 11.5 6.99867C11.5 5.38213 10.404 4.02154 8.91455 3.61941C9.36215 2.94403 10.1291 2.4987 11 2.4987C12.3807 2.4987 13.5 3.61799 13.5 4.9987C13.5 6.01579 12.8926 6.891 12.0208 7.28147C13.8033 7.6964 15.1667 9.173 15.1667 10.9981C15.1667 11.2742 14.9428 11.4981 14.6667 11.4981H12.9165Z"
      fill="currentColor"
      fill-opacity="0.6"
    />
  </svg>
);

const Organization = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M5.28789 0.833335H5.37862C6.24913 0.833315 6.96692 0.833295 7.53505 0.910708C8.13152 0.991975 8.65832 1.16917 9.08012 1.59663C9.50185 2.0241 9.67672 2.55797 9.75692 3.16246C9.83332 3.73824 9.83325 4.46573 9.83325 5.34796V15.1667H5.2879C4.41739 15.1667 3.69956 15.1667 3.13143 15.0893C2.53497 15.008 2.00819 14.8309 1.58641 14.4034C1.16463 13.9759 0.989786 13.4421 0.909593 12.8375C0.833213 12.2617 0.833233 11.5343 0.833253 10.6521V5.34796C0.833233 4.46573 0.833213 3.73824 0.909593 3.16246C0.989786 2.55797 1.16463 2.0241 1.58641 1.59663C2.00819 1.16917 2.53497 0.991975 3.13143 0.910708C3.69956 0.833295 4.41738 0.833315 5.28789 0.833335ZM3.30275 2.20211C2.84885 2.26396 2.63863 2.37301 2.49555 2.51801C2.35247 2.66302 2.24487 2.87608 2.18385 3.33609C2.12033 3.81483 2.11897 4.45414 2.11897 5.39394V10.6061C2.11897 11.5459 2.12033 12.1852 2.18385 12.6639C2.24487 13.1239 2.35247 13.337 2.49555 13.482C2.63863 13.627 2.84885 13.7361 3.30275 13.7979C3.77513 13.8623 4.40594 13.8637 5.33325 13.8637H8.54752V5.39394C8.54752 4.45414 8.54619 3.81483 8.48265 3.33609C8.42165 2.87608 8.31405 2.66302 8.17099 2.51801C8.02785 2.37301 7.81765 2.26396 7.36379 2.20211C6.89139 2.13775 6.26057 2.13637 5.33325 2.13637C4.40594 2.13637 3.77513 2.13775 3.30275 2.20211Z"
      fill="currentColor"
      fill-opacity="0.6"
    />
    <path
      opacity="0.4"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M3 4.66667C3 4.29848 3.29848 4 3.66667 4H4.33333C4.70152 4 5 4.29848 5 4.66667C5 5.03485 4.70152 5.33333 4.33333 5.33333H3.66667C3.29848 5.33333 3 5.03485 3 4.66667ZM5.66667 4.66667C5.66667 4.29848 5.96515 4 6.33333 4H7C7.3682 4 7.66667 4.29848 7.66667 4.66667C7.66667 5.03485 7.3682 5.33333 7 5.33333H6.33333C5.96515 5.33333 5.66667 5.03485 5.66667 4.66667ZM3 7.33333C3 6.96513 3.29848 6.66667 3.66667 6.66667H4.33333C4.70152 6.66667 5 6.96513 5 7.33333C5 7.70153 4.70152 8 4.33333 8H3.66667C3.29848 8 3 7.70153 3 7.33333ZM5.66667 7.33333C5.66667 6.96513 5.96515 6.66667 6.33333 6.66667H7C7.3682 6.66667 7.66667 6.96513 7.66667 7.33333C7.66667 7.70153 7.3682 8 7 8H6.33333C5.96515 8 5.66667 7.70153 5.66667 7.33333ZM3 10C3 9.6318 3.29848 9.33333 3.66667 9.33333H4.33333C4.70152 9.33333 5 9.6318 5 10C5 10.3682 4.70152 10.6667 4.33333 10.6667H3.66667C3.29848 10.6667 3 10.3682 3 10ZM5.66667 10C5.66667 9.6318 5.96515 9.33333 6.33333 9.33333H7C7.3682 9.33333 7.66667 9.6318 7.66667 10C7.66667 10.3682 7.3682 10.6667 7 10.6667H6.33333C5.96515 10.6667 5.66667 10.3682 5.66667 10Z"
      fill="currentColor"
      fill-opacity="0.6"
    />
    <path
      opacity="0.4"
      d="M13.5296 4.88661C13.9481 4.94288 14.326 5.06666 14.6296 5.37031C14.9333 5.67395 15.0571 6.05182 15.1133 6.47035C15.1667 6.86687 15.1666 7.36633 15.1666 7.96533V12.0347C15.1666 12.6337 15.1667 13.1331 15.1133 13.5297C15.0571 13.9482 14.9333 14.3261 14.6296 14.6297C14.326 14.9333 13.9481 15.0571 13.5296 15.1134C13.1331 15.1667 12.6336 15.1667 12.0346 15.1667H8.83325V4.83333H12.0346C12.6336 4.83331 13.1331 4.8333 13.5296 4.88661Z"
      fill="currentColor"
      fill-opacity="0.6"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M11.1667 7.33333C11.1667 7.0572 11.3906 6.83333 11.6667 6.83333H12.3334C12.6095 6.83333 12.8334 7.0572 12.8334 7.33333C12.8334 7.60947 12.6095 7.83333 12.3334 7.83333H11.6667C11.3906 7.83333 11.1667 7.60947 11.1667 7.33333ZM11.1667 10C11.1667 9.72387 11.3906 9.5 11.6667 9.5H12.3334C12.6095 9.5 12.8334 9.72387 12.8334 10C12.8334 10.2761 12.6095 10.5 12.3334 10.5H11.6667C11.3906 10.5 11.1667 10.2761 11.1667 10Z"
      fill="currentColor"
      fill-opacity="0.6"
    />
  </svg>
);

const Engagement = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      opacity="0.4"
      d="M13.5318 7.6746C13.5318 6.27568 13.5301 5.29178 13.4301 4.54775C13.3326 3.82256 13.1523 3.42335 12.8645 3.13557C12.5767 2.8478 12.1776 2.66747 11.4523 2.56994C10.7083 2.4699 9.72442 2.46827 8.32548 2.46825H7.67468C6.27576 2.46824 5.29187 2.46991 4.54783 2.56994C3.82262 2.66746 3.42344 2.84779 3.13566 3.13557C2.84788 3.42336 2.66754 3.82252 2.57002 4.54775C2.46999 5.2918 2.46834 6.27565 2.46834 7.6746V8.3254C2.46834 9.72433 2.46999 10.7082 2.57002 11.4523C2.66754 12.1775 2.84788 12.5767 3.13566 12.8644C3.42345 13.1522 3.82256 13.3332 4.54783 13.4307C5.29187 13.5307 6.27575 13.5317 7.67468 13.5317H8.32548C9.72442 13.5317 10.7083 13.5307 11.4523 13.4307C12.1776 13.3332 12.5767 13.1522 12.8645 12.8644C13.1523 12.5767 13.3326 12.1775 13.4301 11.4523C13.5301 10.7082 13.5318 9.72433 13.5318 8.3254V7.6746ZM14.8334 8.3254C14.8334 9.68753 14.8347 10.7748 14.7203 11.6257C14.6033 12.4953 14.3547 13.2154 13.7847 13.7853C13.2149 14.355 12.4953 14.6033 11.6258 14.7202C10.7749 14.8346 9.68762 14.8333 8.32548 14.8333H7.67468C6.31254 14.8333 5.22526 14.8346 4.37432 14.7202C3.50491 14.6033 2.78525 14.355 2.21539 13.7853C1.64548 13.2154 1.39681 12.4953 1.27988 11.6257C1.16547 10.7748 1.16675 9.68753 1.16675 8.3254V7.6746C1.16675 6.31245 1.16547 5.22519 1.27988 4.37424C1.39681 3.50467 1.6455 2.78522 2.21539 2.21531C2.7853 1.64541 3.50478 1.39672 4.37432 1.27979C5.22525 1.1654 6.31256 1.16665 7.67468 1.16667H8.32548C9.68762 1.16668 10.7749 1.16538 11.6258 1.27979C12.4954 1.39673 13.2149 1.64542 13.7847 2.21531C14.3547 2.78521 14.6033 3.50471 14.7203 4.37424C14.8347 5.22517 14.8334 6.31248 14.8334 7.6746V8.3254Z"
      fill="currentColor"
    />
    <path
      d="M8 4.5C9.38073 4.5 10.5 5.61929 10.5 7C10.5 8.38073 9.38073 9.5 8 9.5C6.61929 9.5 5.5 8.38073 5.5 7C5.5 5.61929 6.61929 4.5 8 4.5Z"
      fill="currentColor"
    />
    <path
      d="M12.931 12.7903C12.275 10.6906 10.316 9.16667 8 9.16667C5.68421 9.16667 3.72462 10.6903 3.06836 12.7897C3.09057 12.815 3.11177 12.8409 3.13541 12.8646C3.42319 13.1523 3.82237 13.3335 4.54753 13.431C5.29155 13.531 6.27561 13.5319 7.67447 13.5319H8.32553C9.7244 13.5319 10.7085 13.531 11.4525 13.431C12.1776 13.3335 12.5768 13.1523 12.8646 12.8646C12.888 12.8411 12.909 12.8154 12.931 12.7903Z"
      fill="currentColor"
    />
  </svg>
);

const Directory = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      opacity="0.4"
      d="M13.5318 7.6746C13.5318 6.27568 13.5301 5.29178 13.4301 4.54775C13.3326 3.82256 13.1523 3.42335 12.8645 3.13557C12.5767 2.8478 12.1776 2.66747 11.4523 2.56994C10.7083 2.4699 9.72442 2.46827 8.32548 2.46825H7.67468C6.27576 2.46824 5.29187 2.46991 4.54783 2.56994C3.82262 2.66746 3.42344 2.84779 3.13566 3.13557C2.84788 3.42336 2.66754 3.82252 2.57002 4.54775C2.46999 5.2918 2.46834 6.27565 2.46834 7.6746V8.3254C2.46834 9.72433 2.46999 10.7082 2.57002 11.4523C2.66754 12.1775 2.84788 12.5767 3.13566 12.8644C3.42345 13.1522 3.82256 13.3332 4.54783 13.4307C5.29187 13.5307 6.27575 13.5317 7.67468 13.5317H8.32548C9.72442 13.5317 10.7083 13.5307 11.4523 13.4307C12.1776 13.3332 12.5767 13.1522 12.8645 12.8644C13.1523 12.5767 13.3326 12.1775 13.4301 11.4523C13.5301 10.7082 13.5318 9.72433 13.5318 8.3254V7.6746ZM14.8334 8.3254C14.8334 9.68753 14.8347 10.7748 14.7203 11.6257C14.6033 12.4953 14.3547 13.2154 13.7847 13.7853C13.2149 14.355 12.4953 14.6033 11.6258 14.7202C10.7749 14.8346 9.68762 14.8333 8.32548 14.8333H7.67468C6.31254 14.8333 5.22526 14.8346 4.37432 14.7202C3.50491 14.6033 2.78525 14.355 2.21539 13.7853C1.64548 13.2154 1.39681 12.4953 1.27988 11.6257C1.16547 10.7748 1.16675 9.68753 1.16675 8.3254V7.6746C1.16675 6.31245 1.16547 5.22519 1.27988 4.37424C1.39681 3.50467 1.6455 2.78522 2.21539 2.21531C2.7853 1.64541 3.50478 1.39672 4.37432 1.27979C5.22525 1.1654 6.31256 1.16665 7.67468 1.16667H8.32548C9.68762 1.16668 10.7749 1.16538 11.6258 1.27979C12.4954 1.39673 13.2149 1.64542 13.7847 2.21531C14.3547 2.78521 14.6033 3.50471 14.7203 4.37424C14.8347 5.22517 14.8334 6.31248 14.8334 7.6746V8.3254Z"
      fill="currentColor"
    />
    <path
      d="M8 4.5C9.38073 4.5 10.5 5.61929 10.5 7C10.5 8.38073 9.38073 9.5 8 9.5C6.61929 9.5 5.5 8.38073 5.5 7C5.5 5.61929 6.61929 4.5 8 4.5Z"
      fill="currentColor"
    />
    <path
      d="M12.931 12.7903C12.275 10.6906 10.316 9.16667 8 9.16667C5.68421 9.16667 3.72462 10.6903 3.06836 12.7897C3.09057 12.815 3.11177 12.8409 3.13541 12.8646C3.42319 13.1523 3.82237 13.3335 4.54753 13.431C5.29155 13.531 6.27561 13.5319 7.67447 13.5319H8.32553C9.7244 13.5319 10.7085 13.531 11.4525 13.431C12.1776 13.3335 12.5768 13.1523 12.8646 12.8646C12.888 12.8411 12.909 12.8154 12.931 12.7903Z"
      fill="currentColor"
    />
  </svg>
);

const Lifecycle = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      opacity="0.4"
      d="M13.5318 7.6746C13.5318 6.27568 13.5301 5.29178 13.4301 4.54775C13.3326 3.82256 13.1523 3.42335 12.8645 3.13557C12.5767 2.8478 12.1776 2.66747 11.4523 2.56994C10.7083 2.4699 9.72442 2.46827 8.32548 2.46825H7.67468C6.27576 2.46824 5.29187 2.46991 4.54783 2.56994C3.82262 2.66746 3.42344 2.84779 3.13566 3.13557C2.84788 3.42336 2.66754 3.82252 2.57002 4.54775C2.46999 5.2918 2.46834 6.27565 2.46834 7.6746V8.3254C2.46834 9.72433 2.46999 10.7082 2.57002 11.4523C2.66754 12.1775 2.84788 12.5767 3.13566 12.8644C3.42345 13.1522 3.82256 13.3332 4.54783 13.4307C5.29187 13.5307 6.27575 13.5317 7.67468 13.5317H8.32548C9.72442 13.5317 10.7083 13.5307 11.4523 13.4307C12.1776 13.3332 12.5767 13.1522 12.8645 12.8644C13.1523 12.5767 13.3326 12.1775 13.4301 11.4523C13.5301 10.7082 13.5318 9.72433 13.5318 8.3254V7.6746ZM14.8334 8.3254C14.8334 9.68753 14.8347 10.7748 14.7203 11.6257C14.6033 12.4953 14.3547 13.2154 13.7847 13.7853C13.2149 14.355 12.4953 14.6033 11.6258 14.7202C10.7749 14.8346 9.68762 14.8333 8.32548 14.8333H7.67468C6.31254 14.8333 5.22526 14.8346 4.37432 14.7202C3.50491 14.6033 2.78525 14.355 2.21539 13.7853C1.64548 13.2154 1.39681 12.4953 1.27988 11.6257C1.16547 10.7748 1.16675 9.68753 1.16675 8.3254V7.6746C1.16675 6.31245 1.16547 5.22519 1.27988 4.37424C1.39681 3.50467 1.6455 2.78522 2.21539 2.21531C2.7853 1.64541 3.50478 1.39672 4.37432 1.27979C5.22525 1.1654 6.31256 1.16665 7.67468 1.16667H8.32548C9.68762 1.16668 10.7749 1.16538 11.6258 1.27979C12.4954 1.39673 13.2149 1.64542 13.7847 2.21531C14.3547 2.78521 14.6033 3.50471 14.7203 4.37424C14.8347 5.22517 14.8334 6.31248 14.8334 7.6746V8.3254Z"
      fill="currentColor"
    />
    <path
      d="M8 4.5C9.38073 4.5 10.5 5.61929 10.5 7C10.5 8.38073 9.38073 9.5 8 9.5C6.61929 9.5 5.5 8.38073 5.5 7C5.5 5.61929 6.61929 4.5 8 4.5Z"
      fill="currentColor"
    />
    <path
      d="M12.931 12.7903C12.275 10.6906 10.316 9.16667 8 9.16667C5.68421 9.16667 3.72462 10.6903 3.06836 12.7897C3.09057 12.815 3.11177 12.8409 3.13541 12.8646C3.42319 13.1523 3.82237 13.3335 4.54753 13.431C5.29155 13.531 6.27561 13.5319 7.67447 13.5319H8.32553C9.7244 13.5319 10.7085 13.531 11.4525 13.431C12.1776 13.3335 12.5768 13.1523 12.8646 12.8646C12.888 12.8411 12.909 12.8154 12.931 12.7903Z"
      fill="currentColor"
    />
  </svg>
);

const Background = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      opacity="0.4"
      d="M13.5318 7.6746C13.5318 6.27568 13.5301 5.29178 13.4301 4.54775C13.3326 3.82256 13.1523 3.42335 12.8645 3.13557C12.5767 2.8478 12.1776 2.66747 11.4523 2.56994C10.7083 2.4699 9.72442 2.46827 8.32548 2.46825H7.67468C6.27576 2.46824 5.29187 2.46991 4.54783 2.56994C3.82262 2.66746 3.42344 2.84779 3.13566 3.13557C2.84788 3.42336 2.66754 3.82252 2.57002 4.54775C2.46999 5.2918 2.46834 6.27565 2.46834 7.6746V8.3254C2.46834 9.72433 2.46999 10.7082 2.57002 11.4523C2.66754 12.1775 2.84788 12.5767 3.13566 12.8644C3.42345 13.1522 3.82256 13.3332 4.54783 13.4307C5.29187 13.5307 6.27575 13.5317 7.67468 13.5317H8.32548C9.72442 13.5317 10.7083 13.5307 11.4523 13.4307C12.1776 13.3332 12.5767 13.1522 12.8645 12.8644C13.1523 12.5767 13.3326 12.1775 13.4301 11.4523C13.5301 10.7082 13.5318 9.72433 13.5318 8.3254V7.6746ZM14.8334 8.3254C14.8334 9.68753 14.8347 10.7748 14.7203 11.6257C14.6033 12.4953 14.3547 13.2154 13.7847 13.7853C13.2149 14.355 12.4953 14.6033 11.6258 14.7202C10.7749 14.8346 9.68762 14.8333 8.32548 14.8333H7.67468C6.31254 14.8333 5.22526 14.8346 4.37432 14.7202C3.50491 14.6033 2.78525 14.355 2.21539 13.7853C1.64548 13.2154 1.39681 12.4953 1.27988 11.6257C1.16547 10.7748 1.16675 9.68753 1.16675 8.3254V7.6746C1.16675 6.31245 1.16547 5.22519 1.27988 4.37424C1.39681 3.50467 1.6455 2.78522 2.21539 2.21531C2.7853 1.64541 3.50478 1.39672 4.37432 1.27979C5.22525 1.1654 6.31256 1.16665 7.67468 1.16667H8.32548C9.68762 1.16668 10.7749 1.16538 11.6258 1.27979C12.4954 1.39673 13.2149 1.64542 13.7847 2.21531C14.3547 2.78521 14.6033 3.50471 14.7203 4.37424C14.8347 5.22517 14.8334 6.31248 14.8334 7.6746V8.3254Z"
      fill="currentColor"
    />
    <path
      d="M8 4.5C9.38073 4.5 10.5 5.61929 10.5 7C10.5 8.38073 9.38073 9.5 8 9.5C6.61929 9.5 5.5 8.38073 5.5 7C5.5 5.61929 6.61929 4.5 8 4.5Z"
      fill="currentColor"
    />
    <path
      d="M12.931 12.7903C12.275 10.6906 10.316 9.16667 8 9.16667C5.68421 9.16667 3.72462 10.6903 3.06836 12.7897C3.09057 12.815 3.11177 12.8409 3.13541 12.8646C3.42319 13.1523 3.82237 13.3335 4.54753 13.431C5.29155 13.531 6.27561 13.5319 7.67447 13.5319H8.32553C9.7244 13.5319 10.7085 13.531 11.4525 13.431C12.1776 13.3335 12.5768 13.1523 12.8646 12.8646C12.888 12.8411 12.909 12.8154 12.931 12.7903Z"
      fill="currentColor"
    />
  </svg>
);

const Compliance = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      opacity="0.4"
      d="M13.5318 7.6746C13.5318 6.27568 13.5301 5.29178 13.4301 4.54775C13.3326 3.82256 13.1523 3.42335 12.8645 3.13557C12.5767 2.8478 12.1776 2.66747 11.4523 2.56994C10.7083 2.4699 9.72442 2.46827 8.32548 2.46825H7.67468C6.27576 2.46824 5.29187 2.46991 4.54783 2.56994C3.82262 2.66746 3.42344 2.84779 3.13566 3.13557C2.84788 3.42336 2.66754 3.82252 2.57002 4.54775C2.46999 5.2918 2.46834 6.27565 2.46834 7.6746V8.3254C2.46834 9.72433 2.46999 10.7082 2.57002 11.4523C2.66754 12.1775 2.84788 12.5767 3.13566 12.8644C3.42345 13.1522 3.82256 13.3332 4.54783 13.4307C5.29187 13.5307 6.27575 13.5317 7.67468 13.5317H8.32548C9.72442 13.5317 10.7083 13.5307 11.4523 13.4307C12.1776 13.3332 12.5767 13.1522 12.8645 12.8644C13.1523 12.5767 13.3326 12.1775 13.4301 11.4523C13.5301 10.7082 13.5318 9.72433 13.5318 8.3254V7.6746ZM14.8334 8.3254C14.8334 9.68753 14.8347 10.7748 14.7203 11.6257C14.6033 12.4953 14.3547 13.2154 13.7847 13.7853C13.2149 14.355 12.4953 14.6033 11.6258 14.7202C10.7749 14.8346 9.68762 14.8333 8.32548 14.8333H7.67468C6.31254 14.8333 5.22526 14.8346 4.37432 14.7202C3.50491 14.6033 2.78525 14.355 2.21539 13.7853C1.64548 13.2154 1.39681 12.4953 1.27988 11.6257C1.16547 10.7748 1.16675 9.68753 1.16675 8.3254V7.6746C1.16675 6.31245 1.16547 5.22519 1.27988 4.37424C1.39681 3.50467 1.6455 2.78522 2.21539 2.21531C2.7853 1.64541 3.50478 1.39672 4.37432 1.27979C5.22525 1.1654 6.31256 1.16665 7.67468 1.16667H8.32548C9.68762 1.16668 10.7749 1.16538 11.6258 1.27979C12.4954 1.39673 13.2149 1.64542 13.7847 2.21531C14.3547 2.78521 14.6033 3.50471 14.7203 4.37424C14.8347 5.22517 14.8334 6.31248 14.8334 7.6746V8.3254Z"
      fill="currentColor"
    />
    <path
      d="M8 4.5C9.38073 4.5 10.5 5.61929 10.5 7C10.5 8.38073 9.38073 9.5 8 9.5C6.61929 9.5 5.5 8.38073 5.5 7C5.5 5.61929 6.61929 4.5 8 4.5Z"
      fill="currentColor"
    />
    <path
      d="M12.931 12.7903C12.275 10.6906 10.316 9.16667 8 9.16667C5.68421 9.16667 3.72462 10.6903 3.06836 12.7897C3.09057 12.815 3.11177 12.8409 3.13541 12.8646C3.42319 13.1523 3.82237 13.3335 4.54753 13.431C5.29155 13.531 6.27561 13.5319 7.67447 13.5319H8.32553C9.7244 13.5319 10.7085 13.531 11.4525 13.431C12.1776 13.3335 12.5768 13.1523 12.8646 12.8646C12.888 12.8411 12.909 12.8154 12.931 12.7903Z"
      fill="currentColor"
    />
  </svg>
);

const Setting = (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      opacity="0.4"
      d="M13.5318 7.6746C13.5318 6.27568 13.5301 5.29178 13.4301 4.54775C13.3326 3.82256 13.1523 3.42335 12.8645 3.13557C12.5767 2.8478 12.1776 2.66747 11.4523 2.56994C10.7083 2.4699 9.72442 2.46827 8.32548 2.46825H7.67468C6.27576 2.46824 5.29187 2.46991 4.54783 2.56994C3.82262 2.66746 3.42344 2.84779 3.13566 3.13557C2.84788 3.42336 2.66754 3.82252 2.57002 4.54775C2.46999 5.2918 2.46834 6.27565 2.46834 7.6746V8.3254C2.46834 9.72433 2.46999 10.7082 2.57002 11.4523C2.66754 12.1775 2.84788 12.5767 3.13566 12.8644C3.42345 13.1522 3.82256 13.3332 4.54783 13.4307C5.29187 13.5307 6.27575 13.5317 7.67468 13.5317H8.32548C9.72442 13.5317 10.7083 13.5307 11.4523 13.4307C12.1776 13.3332 12.5767 13.1522 12.8645 12.8644C13.1523 12.5767 13.3326 12.1775 13.4301 11.4523C13.5301 10.7082 13.5318 9.72433 13.5318 8.3254V7.6746ZM14.8334 8.3254C14.8334 9.68753 14.8347 10.7748 14.7203 11.6257C14.6033 12.4953 14.3547 13.2154 13.7847 13.7853C13.2149 14.355 12.4953 14.6033 11.6258 14.7202C10.7749 14.8346 9.68762 14.8333 8.32548 14.8333H7.67468C6.31254 14.8333 5.22526 14.8346 4.37432 14.7202C3.50491 14.6033 2.78525 14.355 2.21539 13.7853C1.64548 13.2154 1.39681 12.4953 1.27988 11.6257C1.16547 10.7748 1.16675 9.68753 1.16675 8.3254V7.6746C1.16675 6.31245 1.16547 5.22519 1.27988 4.37424C1.39681 3.50467 1.6455 2.78522 2.21539 2.21531C2.7853 1.64541 3.50478 1.39672 4.37432 1.27979C5.22525 1.1654 6.31256 1.16665 7.67468 1.16667H8.32548C9.68762 1.16668 10.7749 1.16538 11.6258 1.27979C12.4954 1.39673 13.2149 1.64542 13.7847 2.21531C14.3547 2.78521 14.6033 3.50471 14.7203 4.37424C14.8347 5.22517 14.8334 6.31248 14.8334 7.6746V8.3254Z"
      fill="currentColor"
    />
    <path
      d="M8 4.5C9.38073 4.5 10.5 5.61929 10.5 7C10.5 8.38073 9.38073 9.5 8 9.5C6.61929 9.5 5.5 8.38073 5.5 7C5.5 5.61929 6.61929 4.5 8 4.5Z"
      fill="currentColor"
    />
    <path
      d="M12.931 12.7903C12.275 10.6906 10.316 9.16667 8 9.16667C5.68421 9.16667 3.72462 10.6903 3.06836 12.7897C3.09057 12.815 3.11177 12.8409 3.13541 12.8646C3.42319 13.1523 3.82237 13.3335 4.54753 13.431C5.29155 13.531 6.27561 13.5319 7.67447 13.5319H8.32553C9.7244 13.5319 10.7085 13.531 11.4525 13.431C12.1776 13.3335 12.5768 13.1523 12.8646 12.8646C12.888 12.8411 12.909 12.8154 12.931 12.7903Z"
      fill="currentColor"
    />
  </svg>
);

const useNav = () => {
  let { state } = useContext(GlobalContext);

  const [navList, setNavList] = useState({
    asideNav: [
      {
        name: "Home",
        icon: <Home size="1em" />,
        url: "",
        activeKey: "dashboards",
      },
      {
        name: "Leads",
        icon: <Users size="1em" />,
        url: "",
        activeKey: "leads",
      },
      {
        name: "Accounts",
        icon: <NotebookPen size="1em" />,
        url: "",
        activeKey: "accounts",
      },
      {
        name: "Deals",
        icon: <Handshake size="1em" />,
        url: "",
        activeKey: "deals",
      },
      {
        name: "Projects",
        icon: <FolderKanban size="1em" />,
        url: "",
        activeKey: "projects",
      },
      {
        name: "Activity",
        icon: <FolderKanban size="1em" />,
        url: "",
        activeKey: "activity",
      },
      {
        name: "Logs",
        icon: <FolderKanban size="1em" />,
        url: "",
        activeKey: "logs",
      },
    ].filter(Boolean),

    LeadsTopHeader: [
      {
        name: "My Leads",
        icon: MySpace,
        url: "/leads/my-leads/dashboard",
        activeKey: "my-leads",
      },
      {
        name: "My Team",
        icon: Team,
        url: "/leads/team/dashboard",
        activeKey: "team",
      },
      {
        name: "Organization",
        icon: Organization,
        url: "/leads/organization/dashboard",
        activeKey: "organization",
      },
    ].filter(Boolean),

    LeadsBottomHeader: [
      // {
      //   name: "Overview",
      //   url: "/leads/my-leads/overview",
      //   activeKey: "overview",
      // },
      {
        name: "Dashboard",
        url: "/leads/my-leads/dashboard",
        activeKey: "dashboard",
      },
      { name: "My Leads", url: "/leads/my-leads/lead", activeKey: "lead" },
    ].filter(Boolean),

    LeadsTeamBottomHeader: [
      // { name: "Overview", url: "/leads/team/overview", activeKey: "overview" },
      {
        name: "Dashboard",
        url: "/leads/team/dashboard",
        activeKey: "dashboard",
      },

      { name: "Team Leads", url: "/leads/team/lead", activeKey: "lead" },
    ].filter(Boolean),

    LeadsOrgBottomHeader: [
      // {
      //   name: "Overview",
      //   url: "/leads/organization/overview",
      //   activeKey: "overview",
      // },
      {
        name: "Dashboard",
        url: "/leads/organization/dashboard",
        activeKey: "dashboard",
      },
      { name: "All Leads", url: "/leads/organization/lead", activeKey: "lead" },
      // { name: "Recycled Leads", url: "/leads/organization/recycled-leads", activeKey: "recycled-leads" },
    ].filter(Boolean),

    WalletsBottomHeader: [
      { name: "Wallets", url: "/walltes/wallet/:id", activeKey: "wallet" },
    ].filter(Boolean),

    WalletsTopHeader: [
      {
        name: "Wallets",
        icon: Organization,
        url: "/walltes/wallet/:id",
        activeKey: "wallet",
      },
    ].filter(Boolean),

    DashbaoardTopHeader: [
      {
        name: "Dashboard",
        icon: Organization,
        url: "/dashboard/overview",
        activeKey: "dashboard",
      },
    ].filter(Boolean),

    DashbaoardBottomHeader: [
      { name: "Overview", url: "/dashboard/overview", activeKey: "overview" },
      { name: "My Data", url: "/dashboard/my-data", activeKey: "my-data" },
      { name: "Team", url: "/dashboard/my-team", activeKey: "my-team" },
      {
        name: "Organization",
        url: "/dashboard/organization",
        activeKey: "organization",
      },
    ].filter(Boolean),

    DevicesBottomHeader: [
      { name: "Devices", url: "/devices/device", activeKey: "device" },
    ].filter(Boolean),

    DevicesTopHeader: [
      {
        name: "Devices",
        icon: Organization,
        url: "/devices/device",
        activeKey: "device",
      },
    ].filter(Boolean),

    OperationsTopHeader: [
      {
        name: "Clients",
        icon: MySpace,
        url: "/operations/client/overview",
        activeKey: "client",
      },
      {
        name: "Agents",
        icon: MySpace,
        url: "/operations/agents/overview",
        activeKey: "agents",
      },
      {
        name: "Account Manager",
        icon: MySpace,
        url: "/operations/account-manager",
        activeKey: "account-manager",
      },
      {
        name: "Teams",
        icon: MySpace,
        url: "/operations/team/overview",
        activeKey: "team",
      },
      {
        name: "Brands",
        icon: MySpace,
        url: "/operations/brand/overview",
        activeKey: "brand",
      },
      {
        name: "Products",
        icon: MySpace,
        url: "/operations/product/product-list",
        activeKey: "product",
      },
      {
        name: "Packages",
        icon: MySpace,
        url: "/operations/package/overview",
        activeKey: "package",
      },
      {
        name: "Merchants",
        icon: MySpace,
        url: "/operations/merchant/overview",
        activeKey: "merchant",
      },
      {
        name: "Lost Deals Reasons",
        icon: MySpace,
        url: "/operations/lost-deals/lost-deal",
        activeKey: "lost-deals",
      },
    ].filter(Boolean),

    AgentsBottomHeader: [
      {
        name: "Overview",
        url: "/operations/agents/overview",
        activeKey: "overview",
      },
      {
        name: "Agent",
        url: "/operations/agents/agent-list",
        activeKey: "agent-list",
      },
    ].filter(Boolean),
    AccountManagerBottomHeader: [
      {
        name: "Account Manager",
        url: "/operations/account-manager",
        activeKey: "account-manager",
      },
    ].filter(Boolean),

    AgentsTopHeader: [
      {
        name: "Agents",
        icon: MySpace,
        url: "/agents/agent",
        activeKey: "agent",
      },
    ].filter(Boolean),

    brandsBottomHeader: [
      {
        name: "Overview",
        url: "/operations/brand/overview",
        activeKey: "overview",
      },
      {
        name: "Brand",
        url: "/operations/brand/brand-list",
        activeKey: "brand-list",
      },
    ].filter(Boolean),

    brandsTopHeader: [
      {
        name: "Brands",
        icon: MySpace,
        url: "/brands/brand",
        activeKey: "brand",
      },
    ].filter(Boolean),

    packagesBottomHeader: [
      {
        name: "Overview",
        url: "/operations/package/overview",
        activeKey: "overview",
      },
      {
        name: "Package",
        url: "/operations/package/package-list",
        activeKey: "package-list",
      },
      {
        name: "Package2",
        url: "/operations/package/package-2",
        activeKey: "package-2",
      },
    ].filter(Boolean),

    packagesTopHeader: [
      {
        name: "Packages",
        icon: MySpace,
        url: "/packages/package",
        activeKey: "package",
      },
    ].filter(Boolean),

    merchantsBottomHeader: [
      {
        name: "Overview",
        url: "/operations/merchant/overview",
        activeKey: "overview",
      },
      {
        name: "Merchant",
        url: "/operations/merchant/merchant-list",
        activeKey: "merchant-list",
      },
      {
        name: "Merchant Type",
        url: "/operations/merchant/merchant-type",
        activeKey: "merchant-type",
      },
    ].filter(Boolean),

    merchantsTopHeader: [
      {
        name: "Merchants",
        icon: MySpace,
        url: "/merchants/merchant",
        activeKey: "merchants",
      },
    ].filter(Boolean),

    lostDealsBottomHeader: [
      {
        name: "Lost Deal Reason",
        url: "/operations/lost-deal",
        activeKey: "lost-deal",
      },
    ].filter(Boolean),

    lostDealsTopHeader: [
      {
        name: "Lost Deals Reasons",
        icon: MySpace,
        url: "/lost-deals/lost-deal",
        activeKey: "lost-deal",
      },
    ].filter(Boolean),

    usersBottomHeader: [
      {
        name: "Overview",
        url: "/operations/client/overview",
        activeKey: "overview",
      },
      {
        name: "Clients",
        url: "/operations/client/client-list",
        activeKey: "client-list",
      },
    ].filter(Boolean),

    usersTopHeader: [
      {
        name: "Clients",
        icon: MySpace,
        url: "/clients/client",
        activeKey: "client",
      },
    ].filter(Boolean),

    productsBottomHeader: [
      // {
      //   name: "Overview",
      //   url: "/operations/product/overview",
      //   activeKey: "overview",
      // },
      {
        name: "Product",
        url: "/operations/product/product-list",
        activeKey: "product-list",
      },
      {
        name: "Category",
        url: "/operations/product/category-list",
        activeKey: "category-list",
      },
      {
        name: "Package",
        url: "/operations/product/package-list",
        activeKey: "package-list",
      },
    ].filter(Boolean),

    productsTopHeader: [
      {
        name: "Products",
        icon: MySpace,
        url: "/products/product",
        activeKey: "product",
      },
    ].filter(Boolean),

    teamsBottomHeader: [
      {
        name: "Overview",
        url: "/operations/team/overview",
        activeKey: "overview",
      },
      {
        name: "Team",
        url: "/operations/team/team-list",
        activeKey: "team-list",
      },
    ].filter(Boolean),

    teamsTopHeader: [
      {
        name: "Teams",
        icon: Team,
        url: "/teams/team",
        activeKey: "team",
      },
    ].filter(Boolean),

    SettingsBottomHeader: [
      { name: "Settings", url: "/settings/setting", activeKey: "setting" },
    ].filter(Boolean),

    SettingsTopHeader: [
      {
        name: "Company Settings",
        icon: MySpace,
        url: "/settings/setting",
        activeKey: "settings",
      },
    ].filter(Boolean),

    LeadDetailBottomHeader: [
      {
        name: "Lead Details",
        // url: "/leads/leadDetail/:id",
        url: "",
        activeKey: "",
      },
    ].filter(Boolean),

    // New Deal Detail Tabs

    // DealContactTopHeader: [
    //   {
    //     name: "Contact Details",
    //     url: "/deals/dealDetail/:id",
    //     activeKey: "dealDetail",
    //   },
    // ].filter(Boolean),

    // DealContactBottomHeader: [
    //   {
    //     name: "Contact Details",
    //     url: "/deals/dealDetail/:id",
    //     activeKey: "dealDetail",
    //   },
    // ].filter(Boolean),

    DealAccountTopHeader: [
      {
        name: "Lead/Account Details",
        icon: MySpace,
        // url: "/lead-account/detail/:id",
        url: "",
        activeKey: "",
      },
    ].filter(Boolean),

    DealAccountBottomHeader: [
      {
        name: "Details",
        url: "",
        activeKey: "",
      },
    ].filter(Boolean),

    ProjectDetailBottomHeader: [
      {
        name: "Project Details",
        // url: "/projects/projectDetail/:key",
        url: "",
        activeKey: "",
      },
    ].filter(Boolean),

    BrandsTopHeader: [
      {
        name: "Brands",
        icon: MySpace,
        url: "/brands/brand",
        activeKey: "brands",
      },
    ].filter(Boolean),

    asideNav2: [
      {
        name: "Operations",
        icon: <Workflow size="1em" />,
        url: "",
        activeKey: "oprations",
        role: "1 2 3",
      },
      {
        name: "Reports",
        icon: <BarChart3 size="1em" />,
        url: "",
        activeKey: "organization-reports",
        role: "1 2 3",
      },
    ].filter(Boolean),

    topHeaderNav: [
      { name: "My Space", icon: MySpace, url: "", activeKey: "my-space" },
      { name: "Team", icon: Team, url: "", activeKey: "team" },
      {
        name: "Organization",
        icon: Organization,
        url: "/organization/employee-directory",
        activeKey: "organization",
      },
    ].filter(Boolean),

    topAccountNav: [
      {
        name: "Accounts",
        icon: MySpace,
        url: "/accounts/account/dashboard",
        activeKey: "account",
      },
      {
        name: "My Team",
        icon: Team,
        url: "/accounts/team/overview",
        activeKey: "team",
      },
      {
        name: "Organization",
        icon: Organization,
        url: "/accounts/organization/overview",
        activeKey: "organization",
      },
    ].filter(Boolean),

    topNotificationNav: [
      {
        name: "Notification",
        icon: MySpace,
        url: "/notification/all",
        activeKey: "notification",
      },

    ].filter(Boolean),

    notificationBottomNav: [
      {
        name: "Notification",
        url: "/notification/all",
        activeKey: "all",
      },
    ].filter(Boolean),

    accountBottomNav: [
      {
        name: "Dashboard",
        url: "/accounts/account/dashboard",
        activeKey: "dashboard",
      },
      {
        name: "Overview",
        url: "/accounts/account/overview",
        activeKey: "overview",
      },

      {
        name: "Account",
        url: "/accounts/account/account-list",
        activeKey: "account-list",
      },
    ].filter(Boolean),

    accountTeamBottomNav: [
      {
        name: "Overview",
        url: "/accounts/team/overview",
        activeKey: "overview",
      },
      {
        name: "Account",
        url: "/accounts/team/account-list",
        activeKey: "account-list",
      },
    ].filter(Boolean),

    accountOrgBottomNav: [
      {
        name: "Overview",
        url: "/accounts/organization/overview",
        activeKey: "overview",
      },
      {
        name: "Account",
        url: "/accounts/organization/account-list",
        activeKey: "account-list",
      },
    ].filter(Boolean),

    accountDetailBottomNav: [
      {
        name: "Account Details",
        url: "/accounts/account-details/:id",
        activeKey: "account-details",
      },
    ].filter(Boolean),

    topActivityNav: [
      {
        name: "Follow Ups",
        icon: MySpace,
        url: "/activites/activity/overview",
        activeKey: "activity",
      },
      {
        name: "My Team",
        icon: Team,
        url: "/activites/team/overview",
        activeKey: "team",
      },
      {
        name: "Organization",
        icon: Organization,
        url: "/activites/organization/overview",
        activeKey: "organization",
      },
    ].filter(Boolean),

    activityBottomNav: [
      {
        name: "Overview",
        url: "/activites/activity/overview",
        activeKey: "overview",
      },
      {
        name: "Follow Ups",
        url: "/activites/activity/activity-list",
        activeKey: "activity-list",
      },
      {
        name: "Activity",
        url: "/activites/activity/my-log",
        activeKey: "my-log",
      },
    ].filter(Boolean),

    activityTeamBottomNav: [
      {
        name: "Overview",
        url: "/activites/team/overview",
        activeKey: "overview",
      },
      {
        name: "Follow Ups",
        url: "/activites/team/activity-list",
        activeKey: "activity-list",
      },
    ].filter(Boolean),

    activityOrgBottomNav: [
      {
        name: "Overview",
        url: "/activites/organization/overview",
        activeKey: "overview",
      },
      {
        name: "Follow Ups",
        url: "/activites/organization/activity-list",
        activeKey: "activity-list",
      },
    ].filter(Boolean),

    saleTopNav: [
      {
        name: "Sales",
        icon: MySpace,
        url: "/sales/sale/overview",
        activeKey: "sale",
      },
      {
        name: "My Team",
        icon: Team,
        url: "/sales/team/overview",
        activeKey: "team",
      },
      {
        name: "Organization",
        icon: Organization,
        url: "/sales/organization/overview",
        activeKey: "organization",
      },
    ].filter(Boolean),

    saleBottomNav: [
      { name: "Overview", url: "/sales/sale/overview", activeKey: "overview" },
      { name: "Sales", url: "/sales/sale/sale-list", activeKey: "sale-list" },
      {
        name: "Assigned Sales",
        url: "/sales/sale/assigned-sale-list",
        activeKey: "assigned-sale-list",
      },
    ].filter(Boolean),

    saleTeamBottomNav: [
      { name: "Overview", url: "/sales/team/overview", activeKey: "overview" },
      {
        name: "Sales",
        url: "/sales/team/sale-list",
        activeKey: "activity-list",
      },
      {
        name: "Assigned Sales",
        url: "/sales/team/assigned-sale-list",
        activeKey: "assigned-sale-list",
      },
    ].filter(Boolean),

    saleOrgBottomNav: [
      {
        name: "Overview",
        url: "/sales/organization/overview",
        activeKey: "overview",
      },
      {
        name: "Sales",
        url: "/sales/organization/sale-list",
        activeKey: "sale-list",
      },
      {
        name: "Assigned Sales",
        url: "/sales/organization/assigned-sale-list",
        activeKey: "assigned-sale-list",
      },
    ].filter(Boolean),

    topLogNav: [
      {
        name: "Activity",
        icon: MySpace,
        url: "/logs/log",
        activeKey: "logs",
      },
    ].filter(Boolean),

    topProjectNav: [
      {
        name: "Projects",
        icon: MySpace,
        url: "/projects/my-projects/dashboard",
        activeKey: "my-projects",
      },
      {
        name: "Team Projects",
        icon: Team,
        url: "/projects/team-projects/dashboard",
        activeKey: "team-projects",
      },
      {
        name: "Organization Projects",
        icon: Organization,
        url: "/projects/organization-projects/dashboard",
        activeKey: "organization-projects",
      },
    ].filter(Boolean),

    topTaskNav: [
      {
        name: "Tasks",
        icon: MySpace,
        url: "/tasks/overview",
        activeKey: "tasks",
      },
    ].filter(Boolean),

    taskBottomNav: [
      { name: "Overview", url: "/tasks/overview", activeKey: "overview" },
      { name: "My Task", url: "/tasks/my-task", activeKey: "my-task" },
    ].filter(Boolean),

    mySpaceBottomNav: [
      { name: "Overview", url: "", activeKey: "overview" },
      { name: "Dashboard", url: "", activeKey: "dashboard" },
      { name: "Calendar", url: "", activeKey: "calendar" },
    ].filter(Boolean),

    contactDetailBottomNav: [
      {
        name: "Contact Details",
        url: "/contacts/contact-details/:id",
        activeKey: "contact-details",
      },
    ].filter(Boolean),

    logsBottomNav: [
      { name: "Activity", url: "/logs/log", activeKey: "log" },
    ].filter(Boolean),

    topRefundNav: [
      {
        name: "Organization",
        icon: Organization,
        url: "/refunds/organization/refund",
        activeKey: "organization",
      },
    ].filter(Boolean),

    refundOrgBottomNav: [
      {
        name: "Overview",
        url: "/refunds/organization/overview",
        activeKey: "overview",
      },

      {
        name: "List",
        url: "/refunds/organization/refund",
        activeKey: "refund",
      },
      {
        name: "By Department",
        url: "/refunds/organization/report-by-department",
        activeKey: "report-by-department",
      },
      {
        name: "By Sales Agent",
        url: "/refunds/organization/report-by-sales-agent",
        activeKey: "report-by-sales-agent",
      },

      {
        name: "By Product",
        url: "/refunds/organization/report-by-product",
        activeKey: "report-by-product",
      },
      {
        name: "By Brand",
        url: "/refunds/organization/report-by-brand",
        activeKey: "report-by-brand",
      },
      {
        name: "By Source",
        url: "/refunds/organization/report-by-source",
        activeKey: "report-by-source",
      },
      {
        name: "By Merchant",
        url: "/refunds/organization/report-by-merchant",
        activeKey: "report-by-merchant",
      },
      {
        name: "By Account Manager",
        url: "/refunds/organization/report-by-account-manager",
        activeKey: "report-by-account-manager",
      },
      {
        name: "By Team Lead",
        url: "/refunds/organization/report-by-team-lead",
        activeKey: "report-by-team-lead",
      },
    ].filter(Boolean),

    brandBottomNav: [
      { name: "Brand", url: "/brands/brand", activeKey: "brand" },
    ].filter(Boolean),

    topDealNav: [
      {
        name: "Deals",
        icon: MySpace,
        url: "/deals/deal/dashboard",
        activeKey: "deal",
      },
      {
        name: "My Team",
        icon: Team,
        url: "/deals/team/dashboard",
        activeKey: "team",
      },
      {
        name: "Organization",
        icon: Organization,
        url: "/deals/organization/dashboard",
        activeKey: "organization",
      },
    ].filter(Boolean),

    dealBottomNav: [
      {
        name: "Dashboard",
        url: "/deals/deal/dashboard",
        activeKey: "dashboard",
      },
      { name: "Overview", url: "/deals/deal/overview", activeKey: "overview" },
      {
        name: "Deal List",
        url: "/deals/deal/deal-list",
        activeKey: "deal-list",
      },
    ].filter(Boolean),

    dealOrgBottomNav: [
      {
        name: "Dashboard",
        url: "/deals/organization/dashboard",
        activeKey: "dashboard",
      },
      {
        name: "Overview",
        url: "/deals/organization/overview",
        activeKey: "overview",
      },
      {
        name: "Deal List",
        url: "/deals/organization/deal-list",
        activeKey: "deal-list",
      },
    ].filter(Boolean),

    dealTeamBottomNav: [
      {
        name: "Dashboard",
        url: "/deals/team/dashboard",
        activeKey: "dashboard",
      },
      { name: "Overview", url: "/deals/team/overview", activeKey: "overview" },
      {
        name: "Deal List",
        url: "/deals/team/deal-list",
        activeKey: "deal-list",
      },
    ].filter(Boolean),

    projectBottomNav: [
      {
        name: "Dashboard",
        url: "/projects/my-projects/dashboard",
        activeKey: "dashboard",
      },
      {
        name: "Project",
        url: "/projects/my-projects/project",
        activeKey: "project",
      },
    ].filter(Boolean),
    teamprojectBottomNav: [
      {
        name: "Dashboard",
        url: "/projects/team-projects/dashboard",
        activeKey: "dashboard",
      },
      {
        name: "Project",
        url: "/projects/team-projects/project",
        activeKey: "project",
      },
    ].filter(Boolean),
    orgprojectBottomNav: [
      {
        name: "Dashboard",
        url: "/projects/organization-projects/dashboard",
        activeKey: "dashboard",
      },
      {
        name: "Project",
        url: "/projects/organization-projects/project",
        activeKey: "project",
      },
    ].filter(Boolean),

    organizationBottomNav: [
      { name: "Overview", url: "", activeKey: "overview" },
      { name: "Announcements", url: "", activeKey: "announcements" },
      { name: "Policies", url: "", activeKey: "policies" },
      { name: "Employee Tree", url: "", activeKey: "employee-tree" },
      { name: "Department Tree", url: "", activeKey: "department-tree" },
      {
        name: "Employee Directory",
        url: "employee-directory",
        activeKey: "employee-directory",
      },
      { name: "Birthday Folks", url: "", activeKey: "birthday-folks" },
      { name: "New Hires", url: "", activeKey: "new-hires" },
    ].filter(Boolean),

    // System Settings
    systemSettingsBottomHeader: [
      {
        name: "Setting List",
        url: "/system-settings",
        activeKey: "system-settings",
      },
    ].filter(Boolean),

    systemSettingsTopHeader: [
      {
        name: "System Settings",
        icon: Organization,
        url: "/system-settings",
        activeKey: "system-settings",
      },
    ].filter(Boolean),

    // Lead Status
    leadStatusBottomHeader: [
      {
        name: "Lead Status",
        url: "/lead-status",
        activeKey: "lead-status",
      },
    ].filter(Boolean),

    leadStatusTopHeader: [
      {
        name: "Lead Status",
        icon: MySpace,
        url: "/lead-status",
        activeKey: "lead-status",
      },
    ].filter(Boolean),

    // client Renewal Status
    clientRenewalsBottomHeader: [
      {
        name: "Renewals Tracker",
        url: "/renewals-tracker",
        activeKey: "renewals-tracker",
      },
    ].filter(Boolean),

    clientRenewalsTopHeader: [
      {
        name: "Renewals Tracker",
        icon: Organization,
        url: "/renewals-tracker",
        activeKey: "renewals-tracker",
      },
    ].filter(Boolean),

    clientHealthBottomHeader: [
      {
        name: "Health Score Factor",
        url: "/client-health/health-score-factor",
        activeKey: "health-score-factor",
      },
      {
        name: "Health Score Thresholds",
        url: "/client-health/health-score-thresholds",
        activeKey: "health-score-thresholds",
      },
      {
        name: "Priority Flags",
        url: "/client-health/priority-flags",
        activeKey: "priority-flags",
      },
    ].filter(Boolean),

    clientHealthTopHeader: [
      {
        name: "Client Health",
        icon: MySpace,
        url: "/client-health/health-score-factor",
        activeKey: "client-health",
      },
    ].filter(Boolean),
  });

  const checkCondi = state?.user?.dashboardRole === "single";

  console.log("checkCondi", checkCondi, state?.user?.dashboardRole);

  // const allowKeys = ["DashbaoardTopHeader", "DashbaoardBottomHeader"];
  const allowKeys = ["", ""];

  const finalNavList = checkCondi
    ? Object.fromEntries(
      Object.entries(navList).map(([key, navArray]) => [
        key,
        navArray.map((item) => ({
          ...item,
          url: allowKeys.includes(key) ? item.url : "",
        })),
      ]),
    )
    : navList;

  // console.log("finalNavList", finalNavList);

  return finalNavList;
};

export default useNav;
